import { isWeb } from "@memorang/helpers/platform";
import { useDevice } from "@memorang/ui/useDevice";
import { useRouter } from "expo-router";
import { useCallback } from "react";

export const useCustomNavigation = () => {
	const { isMobile } = useDevice();

	const router = useRouter();

	const handleSuggestCorrectionNavigation = (
		toggleSuggestCorrection: () => void,
		itemId?: string,
	) => {
		const navigateToSuggestCorrection = () => {
			router.push({
				pathname: "/feedback",
				params: {
					itemId,
				},
			});
		};

		if (isWeb) {
			if (isMobile) {
				navigateToSuggestCorrection();
			} else {
				toggleSuggestCorrection();
			}
		} else {
			navigateToSuggestCorrection();
		}
	};

	const handleFeedbackNavigation = useCallback(
		(toggleFeedback: () => void) => {
			const navigateToFeedback = () => {
				router.push("/(protected)/feedback");
			};

			if (isWeb) {
				if (isMobile) {
					navigateToFeedback();
				} else {
					toggleFeedback();
				}
			} else {
				navigateToFeedback();
			}
		},
		[isMobile, router],
	);

	return {
		handleSuggestCorrectionNavigation,
		handleFeedbackNavigation,
	};
};
